import { WebGLRenderer, Scene, Camera } from 'three';

export const downloadSnapshotClick = (
  gl: WebGLRenderer,
  scene: Scene,
  camera: Camera
) => {
  gl.render(scene, camera);
  const dataURL = gl.domElement.toDataURL('image/png');

  const link = document.createElement('a');
  link.href = dataURL;
  link.download = 'snapshot.png';
  link.click();
};
